export default {
    affiliatePriorities: [
        { value: 1, text: 'High' },
        { value: 2, text: 'Medium' },
        { value: 3, text: 'New' },
        { value: 4, text: 'Low' },
        { value: 5, text: 'Very Low' },
    ],
}
